module.exports = __webpack_public_path__ + "media/images/order/waiting_schedule-2dd5afc9e8b1a8c4513a7980fa6a029b.jpg";